import React from "react";
import { Building2, Landmark, TrendingUp } from "lucide-react";

const PROBLEMS = [
  {
    icon: <Building2 size={22} />,
    audience: "MSMEs",
    headline: "No visibility into carbon exposure",
    body:
      "India's 63 million MSMEs lack the tools, data, and expertise to understand their carbon intensity — making them invisible to sustainability-linked finance and global supply chains.",
  },
  {
    icon: <Landmark size={22} />,
    audience: "Banks & NBFCs",
    headline: "No scalable carbon screening tool",
    body:
      "Financial institutions face regulatory pressure to assess climate risk in lending portfolios, but no cost-effective screening mechanism exists for MSME borrowers at scale.",
  },
  {
    icon: <TrendingUp size={22} />,
    audience: "ESG & Supply Chain",
    headline: "Full GHG accounting is prohibitively costly",
    body:
      "Conventional GHG inventories require primary data collection, third-party verification, and significant time investment — inaccessible for most MSMEs and high-volume screening contexts.",
  },
];

export default function SocialProof() {
  return (
    <section className="problem-section" id="problem">
      <div className="landing-container">
        <div className="section-label">THE PROBLEM</div>
        <h2 className="section-title">
          The Gap in Carbon Risk Visibility
        </h2>
        <p className="section-sub">
          Existing frameworks weren't designed for the scale, cost constraints,
          and data availability challenges of Indian MSMEs and their financial ecosystems.
        </p>

        <div className="problem-grid">
          {PROBLEMS.map((p, i) => (
            <div key={i} className="problem-card">
              <div className="problem-card-icon">{p.icon}</div>
              <div className="problem-card-audience">{p.audience}</div>
              <h3 className="problem-card-headline">{p.headline}</h3>
              <p className="problem-card-body">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
